/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BotResponse
 */
export interface BotResponse {
    /**
     * 
     * @type {string}
     * @memberof BotResponse
     */
    botResponse: string;
    /**
     * 
     * @type {string}
     * @memberof BotResponse
     */
    id: string;
    /**
     * 
     * @type {object}
     * @memberof BotResponse
     */
    citations: object;
    /**
     * 
     * @type {boolean}
     * @memberof BotResponse
     */
    streaming: boolean;
}

/**
 * Check if a given object implements the BotResponse interface.
 */
export function instanceOfBotResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "botResponse" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "citations" in value;
    isInstance = isInstance && "streaming" in value;

    return isInstance;
}

export function BotResponseFromJSON(json: any): BotResponse {
    return BotResponseFromJSONTyped(json, false);
}

export function BotResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BotResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'botResponse': json['botResponse'],
        'id': json['id'],
        'citations': json['citations'],
        'streaming': json['streaming'],
    };
}

export function BotResponseToJSON(value?: BotResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'botResponse': value.botResponse,
        'id': value.id,
        'citations': value.citations,
        'streaming': value.streaming,
    };
}

